export const getCookie = (name) => {
  const cookie = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return cookie ? cookie[2] : null;
};

// Function to set a cookie with the name `access_token` and expiry of 1 hour
export const setCookie = (name, value, hours) => {
  const date = new Date();
  date.setTime(date.getTime() + hours * 60 * 60 * 1000); // Set expiry to 1 hour
  document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
};